import { ContextMenuButton, Td, Tr } from 'app/components/Table';
import { MouseEvent } from 'react';
import { Row } from '@tanstack/react-table';
import { ListItemAvatar, ListItemText } from 'app/components/ChakraTableList';
import { getAvatarImage } from 'app/utils/utils';
import {
  getAvatarColorsArray,
  getRandomColor,
} from 'app/components/Core/ChakraAvatar/utils';
import { Representative } from 'types/profile';
import { Theme, useTheme } from '@chakra-ui/react';

interface RepresentativesTableRowProps {
  row: Row<Representative>;
  contextHandler: (e: MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
}

export const RepresentativesTableRow = ({
  row,
  contextHandler,
}: RepresentativesTableRowProps) => {
  const theme = useTheme<Theme>();
  const {
    firstName,
    lastName,
    email,
    role,
    company,
    publisherIpi,
  } = row.original;

  const initials = [firstName?.[0] || '', lastName?.[0] || ''].join('');
  const randomColor = getRandomColor(getAvatarColorsArray(theme), initials);

  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      data-group
      onContextMenu={contextHandler}
    >
      <Td isAvatar sx={{ overflow: 'visible' }}>
        <ListItemAvatar
          src={getAvatarImage([])}
          initials={initials}
          colors={{
            background: randomColor[200],
            text: randomColor[500],
          }}
        />
      </Td>
      <Td sx={{ pl: 0 }}>
        <ListItemText
          data-testid="name-type"
          primary={[firstName, lastName].join(' ')}
        />
      </Td>
      <Td>
        <ListItemText data-testid="email-text" primary={email} />
      </Td>
      <Td>
        <ListItemText data-testid="role-text" primary={role} />
      </Td>
      <Td>
        <ListItemText data-testid="company-text" primary={company} />
      </Td>
      <Td>
        <ListItemText
          data-testid="role-text"
          primary={publisherIpi?.toString()}
        />
      </Td>
      <Td />
      <Td>
        <ContextMenuButton onClick={contextHandler} />
      </Td>
    </Tr>
  );
};
